import React, { useContext } from "react"
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  useTheme
} from "@carrotfertility/carotene-core"
import { RequiredItemModalsContext } from "./RequiredItemModalsContext"

export function RequiredItemChangeConfirmationModal(): JSX.Element {
  const theme = useTheme()
  const context = useContext(RequiredItemModalsContext)

  if (!context) {
    return <></>
  }

  const { confirmRemovalIsOpen, onConfirmRemoval, closeConfirmRemovalModal } = context

  return (
    <Dialog
      open={confirmRemovalIsOpen}
      onClose={closeConfirmRemovalModal}
      aria-labelledby="required-item-change-confirm-dialog-title"
    >
      <DialogTitle id="required-item-change-confirm-dialog-title">Confirm change</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {`This item is required by the member\u0027s benefit configuration. Are you sure you want to remove it?`}
        </DialogContentText>
        <DialogActions sx={{ paddingTop: theme.spacing(theme.tokens.spacing.sm) }}>
          <Button type="button" color="secondary" variant="outlined" onClick={closeConfirmRemovalModal}>
            Cancel
          </Button>
          <Button type="button" color="primary" variant="contained" onClick={onConfirmRemoval}>
            Remove
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  )
}
